<template>
  <div>
    <v-btn disabled v-if='!item[column.name]' @click='addInterval()' class='download-csv-template' color="#5aa2ee" icon text>
      <v-icon medium color="#5AA2EE" :class="{'material-icons-outlined':(true)}"> add </v-icon>
      {{ $t('add.interval.btn') }}
    </v-btn>
    <div class='label' v-else>
      {{ intervalData }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'IntervalTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      intervalData: '',
    };
  },
  methods: {
    addInterval() {
      this.$emit('add-interval', this.item.id);
      this.intervalData = 'January , 1 - December, 31, 2020 Every 2 days 2-4 PM GMT+3';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.download-csv-template {
  height: 16px;
  width: 94px;
  font-family: $font-family-medium;
  color: var(--info-500);
  font-size: $font-size-sm;
  font-weight: 500;
  letter-spacing: 1.07px;
  line-height: $font-size-md;
  text-align: center;
}
.label {
  padding-top: 10px;
  height: 32px;
  width: 196px;
  color: var(--text-tertiary);
  font-family: $font-family-medium;
  font-size: $font-size-base;
  letter-spacing: 0;
  line-height: $font-size-md;
}
</style>
